import FinanceTrends from './FinanceTrends';

export default FinanceTrends;
